import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import { FieldRenderProps } from 'react-final-form'

const WrappedCheckbox = ({
  input: { checked, name, onChange, ...restInput },
  meta,
  ...rest
}: FieldRenderProps<
  unknown,
  HTMLElement,
  string | number | readonly string[] | undefined
>) => (
  <Checkbox
    {...rest}
    name={name}
    inputProps={restInput}
    onChange={onChange}
    checked={checked}
  />
)

export default WrappedCheckbox
